// removed by extract-text-webpack-plugin
module.exports = {" _key":"ticker/GameInfo","gameinfobox":"_1aZEq0Cs","teamboxleft":"FvPXEGWZ","teamboxright":"_75d4ALm1","teamname":"_3os-5FwD"};


//////////////////
// WEBPACK FOOTER
// ./src/widgets/styles/GameInfo.m.css
// module id = ./src/widgets/styles/GameInfo.m.css
// module chunks = main